// Hilfsfunktionen rund um die Fahrtdauer.
//
// Hintergrund: Fahrten tragen `estimatedTimeMinutes` (geschätzte Fahrzeit, vor
// Fahrtbeginn berechnet). Das Alt-Feld `duration` wurde nie geschrieben. Bei
// abgeschlossenen Fahrten ist jedoch die TATSÄCHLICH gefahrene Dauer
// aussagekräftiger als die Schätzung — sie wird hier aus den serverseitigen
// Zeitstempeln (passengerPickedUp → completed) abgeleitet.

// Firestore-Timestamp / Date / String in ein JS-Date umwandeln (oder null).
export const toJsDate = (value) => {
  if (!value) return null;
  let date;
  if (value.toDate) date = value.toDate();
  else if (value.seconds) date = new Date(value.seconds * 1000);
  else date = new Date(value);
  return isNaN(date.getTime()) ? null : date;
};

// Tatsächlich gefahrene Dauer (Abholung → Abschluss) in Minuten, sonst null.
// Fällt für die Abholung auf `startedAt` zurück, falls kein
// `passengerPickedUpTimestamp` existiert.
//
// Eine abgeschlossene Fahrt mit gültigen Zeitstempeln liefert IMMER ihre echte
// Dauer — auch 0 Min. (z. B. unmittelbar nach der Abholung abgeschlossen). Auf
// die Schätzung fällt der Aufrufer nur zurück, wenn keine Zeitstempel vorliegen
// (null) — sonst würden gerade die kaputten Schätzwerte (z. B. 8730 Min. aus dem
// (0,0)-Ziel-Bug) statt der realen Dauer angezeigt. Negative Werte (Uhr-Drift /
// Abschluss vor Abholung) gelten als ungültig → null.
export const getActualRideDurationMinutes = (ride) => {
  if (!ride) return null;
  const start = toJsDate(ride.passengerPickedUpTimestamp || ride.startedAt);
  const end = toJsDate(ride.completedTimestamp || ride.completionTimestamp);
  if (!start || !end) return null;
  const minutes = Math.round((end.getTime() - start.getTime()) / 60000);
  return minutes >= 0 ? minutes : null;
};
